export const ROUTES = Object.freeze({
  login: '/login',
  dashboard: '/dashboard',
  pdvActive: '/pdv/attivi',
  pdvMaster: '/pdv/master',
  map: '/mappa',
  planning: '/planning',
  planningNew: '/planning/nuovo',
  visits: '/visite',
  visitsNew: '/visite/nuova',
  sales: '/vendite',
  salesTpoint: '/vendite/tpoint',
  salesGrabGo: '/vendite/grab-go',
  issues: '/segnalazioni',
  issuesNew: '/segnalazioni/nuova',
  reports: '/report',
  users: '/amministrazione/utenti',
  imports: '/amministrazione/import',
  audit: '/amministrazione/audit',
  account: '/account'
});
